import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => {
  const loc = useLocation();
  const parts = items.length
    ? items
    : loc.pathname
        .split("/")
        .filter(Boolean)
        .map((seg, i, arr) => ({
          label: seg.replace(/-/g, " "),
          to: "/" + arr.slice(0, i + 1).join("/"),
        }));

  return (
    <nav
      className="flex items-center gap-2 text-xs uppercase tracking-widest text-slateink"
      data-testid="breadcrumbs"
    >
      <Link to="/" className="hover:text-edge flex items-center gap-1">
        <Home className="w-3 h-3" /> Home
      </Link>
      {parts.map((p, i) => (
        <span key={i} className="flex items-center gap-2">
          <ChevronRight className="w-3 h-3" />
          {i === parts.length - 1 ? (
            <span className="text-white">{p.label}</span>
          ) : (
            <Link to={p.to} className="hover:text-edge">
              {p.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
